import Vue from 'vue'

// 单编辑模块组件：名称+编辑区域
// import pre_input from './pre_input.vue'
import prenumber from './pre_number.vue'
import pretext from './pre_text_1.0.vue'
import prelabel from './pre_label.vue'
import pretextarea from './pre_textarea.vue'
import pretextareaedit from './pre_textareaedit.vue'
import predate from './pre_date.vue'
import preweek from './pre_date_week.vue'
import premonth from './pre_date_month.vue'
import preyear from './pre_date_year.vue'
import predatetime from './pre_datetime.vue'
import preselect from './pre_select.vue'
import preradio from './pre_radio.vue'

import pretan from './pre_tan.vue'
import prespan from './pre_span.vue'
import prenone from './pre_none.vue'
import preselectnew from './pre_selectnew.vue'
import prefile from './pre_file.vue'
import preswitch from './pre_switch.vue'

import prefilelist from './pre_file_list.vue'


const components = {
	// pre_input,
	predate,
	preweek,
	premonth,
	preyear,
	predatetime,
	preselect,
	prenumber,
	pretext,
	pretextarea,
	pretextareaedit,
	preradio,
	prefile: prefile,
	pretan,
	prespan,
	prenone,
	preselectnew,
	preswitch,
	prelabel,
	prefilelist

};

const install = function(Vue, opts = {}) {
	Object.keys(components).forEach((key) => {
		Vue.component(key, components[key]);
	});
};

export default install;